import React from 'react';
import * as PropTypes from 'prop-types';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Button from './Button';
import { SubjectPropType } from '../../abilities/proptypes';

const AcceptButton = ({
    children,
    onClick,
    disabled,
    subject,
    action,
    className,
    variant,
    color,
    size,
}) => (
    <Button
        startIcon={<CheckCircleOutlineIcon />}
        onClick={onClick}
        disabled={disabled}
        subject={subject}
        action={action}
        variant={variant}
        color={color}
        size={size}
        className={className}
    >
        {children || 'Akzeptieren'}
    </Button>
);

AcceptButton.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    subject: SubjectPropType,
    action: PropTypes.string,
    variant: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    className: PropTypes.string,
};

AcceptButton.defaultProps = {
    children: null,
    onClick: null,
    disabled: false,
    subject: null,
    action: null,
    variant: undefined,
    color: undefined,
    size: undefined,
    className: null,
};

export default AcceptButton;
